module.exports = __webpack_public_path__ + "static/media/houzz-m-rgb-la-w.b70ad3b1.svg";